import { useEffect, useState, createContext } from "react";
import { HiVideoCamera } from "react-icons/hi";
import { TabPanel } from "../../components/TabPanel";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "../../components/Input";
import { DashboardClienti } from "./DashboardClienti";
import { PayrollClienti } from "./PayrollClienti";
import {
  MdBarChart,
  MdCheck,
  MdContactPhone,
  MdPayments,
} from "react-icons/md";
import { toast } from "react-toastify";
import { FaFileSignature } from "react-icons/fa6";
import { Button } from "../../components/Button";
import { AssunzioniClienti } from "./AssunzioniClienti";
import { RecapitiClienti } from "./RecapitiClienti";
import {
  HiOutlineChartPie,
  HiOutlineCheck,
  HiOutlineClipboardDocumentCheck,
  HiOutlineCurrencyEuro,
  HiOutlineGlobeAlt,
  HiOutlinePlus,
  HiOutlineRectangleGroup,
} from "react-icons/hi2";
import { PrincipalButton } from "../../components/PrincipalButton";
import api from "../../api/api";
import { useBlocker } from "react-router-dom";
import { createPortal } from "react-dom";
import Modal from "../../components/Modal";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { MdMergeType } from "react-icons/md";
import { knowAcces } from "../../utils/utils";

export const DettaglioClienti = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(location.state?.cliente || null);
  const [tab, setTab] = useState(1);
  const [block, setBlock] = useState(false);
  const [modal, setModal] = useState(false);
  // Stato per modal "Unifica azienda"
  const [unificaOpen, setUnificaOpen] = useState(false);
  const [unificaCodiceNuovo, setUnificaCodiceNuovo] = useState("");
  const [unificaCliente, setUnificaCliente] = useState(null); // dati azienda destinazione
  const [unificaLoading, setUnificaLoading] = useState(false);
  const [unificaConfirm, setUnificaConfirm] = useState(false); // doppia conferma
  const isAdmin = knowAcces(["admin"]);
  const isAmministrazioneReadOnly = knowAcces(["amministrazione"]) && !knowAcces([
    "admin", "team_leader", "paghe", "assunzioni", "segreteria", "f24", "consulente",
  ]);

  const handleVerificaCodiceNuovo = async () => {
    if (!unificaCodiceNuovo || unificaCodiceNuovo === cliente?.codice_univoco) {
      toast.error("Inserire un codice univoco valido e diverso dal corrente");
      return;
    }
    try {
      const response = await api.get(`/aziende/${unificaCodiceNuovo}`);
      if (!response.data) {
        toast.error("Azienda destinazione non trovata");
        setUnificaCliente(null);
        return;
      }
      setUnificaCliente(response.data);
      setUnificaConfirm(true);
    } catch (err) {
      toast.error("Azienda destinazione non trovata");
      setUnificaCliente(null);
    }
  };

  const handleUnificaConferma = async () => {
    setUnificaLoading(true);
    try {
      const res = await api.post("/aziende/unifica", {
        codice_vecchio: cliente.codice_univoco,
        codice_nuovo: unificaCodiceNuovo,
      });
      toast.success(`Unificazione completata: ${cliente.codice_univoco} → ${unificaCodiceNuovo}`);
      console.log("Report unificazione:", res.data);
      setUnificaOpen(false);
      setUnificaConfirm(false);
      setUnificaCodiceNuovo("");
      setUnificaCliente(null);
      // Reindirizza al dettaglio della nuova azienda
      navigate("/Clienti/Dettaglio", {
        state: { cliente: { codice_univoco: unificaCodiceNuovo } },
      });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Errore durante l'unificazione");
    } finally {
      setUnificaLoading(false);
    }
  };

  const handleCloseUnifica = () => {
    setUnificaOpen(false);
    setUnificaConfirm(false);
    setUnificaCodiceNuovo("");
    setUnificaCliente(null);
  };

  useEffect(() => {
    const loadCliente = async () => {
      // Se non abbiamo il cliente o abbiamo solo il codice_univoco, carica da API
      const codice_univoco = location.state?.cliente?.codice_univoco;

      if (!codice_univoco) {
        toast.error("Codice univoco non trovato");
        // navigate("/Clienti");
        return;
      }

      try {
        const response = await api.get(`/aziende/${codice_univoco}`);
        setCliente(response.data);
      } catch (error) {
        toast.error("Errore nel caricamento del cliente");
        console.error("Error loading cliente:", error);
        // Mantieni i dati precedenti in caso di errore
      }
    };

    loadCliente();
  }, [location.state?.cliente?.codice_univoco]);

  const handleBeforeUnload = (event) => {
    // per il refresh
    event.preventDefault();
    event.returnValue =
      "Sono state rilevate modifiche,  sei sicuro di voler ricaricare la pagina?"; // Chrome requires returnValue to be set
  };

  const [tabs, setTabs] = useState([
    {
      icon: <HiOutlineChartPie size={26} className="tab-icon" />,
      text: "Dashboard",
      id: 1,
    },
    {
      icon: <HiOutlineCurrencyEuro size={26} className="tab-icon" />,
      text: "Payroll",
      id: 2,
    },
    {
      icon: <HiOutlineClipboardDocumentCheck size={26} className="tab-icon" />,
      text: "Assunzioni",
      id: 3,
    },
    {
      icon: <HiOutlineGlobeAlt size={26} className="tab-icon" />,
      text: "Recapiti/altri servizi",
      id: 4,
    },
  ]);

  const handleSave = async () => {
    if (isAmministrazioneReadOnly) return;
    try {
      const aziende = await api.put(`/aziende`, { azienda: cliente });
      setBlock(false);
      toast.success("SALVATAGGIO OK");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    } catch {
      toast.error("ERRORE NEL SALVATAGGIO");
    }
  };

  const handleChange = (e) => {
    if (isAmministrazioneReadOnly) return;
    let c = { ...cliente };
    c[e.target.name] = e.target.value;
    setCliente(c);
    setBlock(true);
    window.addEventListener("beforeunload", handleBeforeUnload);
  };

  const handleChangeSelect = (e, name) => {
    if (isAmministrazioneReadOnly) return;
    let c = { ...cliente };
    c[name] = e.target.value;
    setCliente(c);
    setBlock(true);
    window.addEventListener("beforeunload", handleBeforeUnload);
  };

  const handleChangeCheckbox = (e, name) => {
    if (isAmministrazioneReadOnly) return;
    let c = { ...cliente };
    c[name] = e.target.checked ? 1 : 0;
    setCliente(c);

    setBlock(true);
    window.addEventListener("beforeunload", handleBeforeUnload);
  };

  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      block && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (blocker.state === "blocked") {
      setModal(true);
    }
  }, [blocker]);

  /*const [content, setContent] = useState([
    { child: <DashboardClienti  cliente={cliente} handleSave={handleSave} handleChange={handleChange}/>, id: 1 },
    { child: <PayrollClienti cliente={cliente} />, id: 2 },
    { child: <AssunzioniClienti cliente={cliente} />, id: 3 },
    { child: <RecapitiClienti cliente={cliente} />, id: 4 },
  ]);*/

  const content = [
    {
      child: (
        <DashboardClienti
          cliente={cliente}
          handleSave={handleSave}
          handleChange={handleChange}
          handleChangeSelect={handleChangeSelect}
          handleChangeCheckbox={handleChangeCheckbox}
          readOnly={isAmministrazioneReadOnly}
        />
      ),
      id: 1,
    },
    {
      child: (
        <PayrollClienti
          cliente={cliente}
          handleSave={handleSave}
          handleChange={handleChange}
          handleChangeSelect={handleChangeSelect}
          readOnly={isAmministrazioneReadOnly}
        />
      ),
      id: 2,
    },
    {
      child: (
        <AssunzioniClienti
          cliente={cliente}
          handleChangeCheckbox={handleChangeCheckbox}
          handleSave={handleSave}
          handleChange={handleChange}
          handleChangeSelect={handleChangeSelect}
          readOnly={isAmministrazioneReadOnly}
        />
      ),
      id: 3,
    },
    {
      child: (
        <RecapitiClienti
          cliente={cliente}
          handleChangeCheckbox={handleChangeCheckbox}
          handleSave={handleSave}
          handleChange={handleChange}
          handleChangeSelect={handleChangeSelect}
          readOnly={isAmministrazioneReadOnly}
        />
      ),
      id: 4,
    },
  ];

  useEffect(() => setCliente(location.state.cliente), []);

  return (
    <>
      {modal &&
        createPortal(
          <Modal
            isOpen={modal}
            closeButton={() => setModal(false)}
            headerText={"ATTENZIONE!"}
            rightButtons={
              <Button
                className="success-button"
                size="md"
                text={"Conferma"}
                onClick={() => blocker.proceed?.()}
                icon={<AiOutlineCheck size={20} />}
              />
            }
            leftButtons={
              <Button
                className="error-button"
                size="md"
                text={"Annulla"}
                onClick={() => setModal(false)}
                icon={<AiOutlineClose size={20} />}
              />
            }
          >
            <div className="el-container">
              Sono state rilevate modifiche, sei sicuro di voler lasciare la
              pagina?
            </div>
          </Modal>,
          document.getElementById("portalModal")
        )}
      {/* Bottone "Unifica azienda" - solo per admin */}
      {isAdmin && cliente && (
        <div className="flex justify-end px-4 pt-2">
          <Button
            className="warning-button"
            size="sm"
            text="Unifica azienda"
            icon={<MdMergeType size={18} />}
            onClick={() => setUnificaOpen(true)}
            title="Unifica questa azienda con il nuovo codice univoco (sposta tutto lo storico)"
          />
        </div>
      )}

      {/* Modal Unifica */}
      {unificaOpen &&
        createPortal(
          <Modal
            isOpen={unificaOpen}
            closeButton={handleCloseUnifica}
            headerText={"Unifica azienda duplicata"}
            rightButtons={
              !unificaConfirm ? (
                <Button
                  className="success-button"
                  size="md"
                  text={"Verifica codice"}
                  onClick={handleVerificaCodiceNuovo}
                  icon={<AiOutlineCheck size={20} />}
                />
              ) : (
                <Button
                  className="success-button"
                  size="md"
                  text={unificaLoading ? "Unificazione in corso..." : "Conferma unificazione"}
                  onClick={handleUnificaConferma}
                  icon={<AiOutlineCheck size={20} />}
                  disabled={unificaLoading}
                />
              )
            }
            leftButtons={
              <Button
                className="error-button"
                size="md"
                text={"Annulla"}
                onClick={handleCloseUnifica}
                icon={<AiOutlineClose size={20} />}
                disabled={unificaLoading}
              />
            }
          >
            <div className="el-container" style={{ minWidth: 480 }}>
              {!unificaConfirm ? (
                <>
                  <p style={{ marginBottom: 8 }}>
                    <strong>Azienda corrente (vecchio codice):</strong>
                  </p>
                  <p style={{ marginBottom: 16 }}>
                    {cliente?.codice_univoco} — {cliente?.ragione_sociale}
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    Inserisci il <strong>codice univoco nuovo</strong> su cui spostare tutto lo storico:
                  </p>
                  <Input
                    name="codice_nuovo"
                    value={unificaCodiceNuovo}
                    onChange={(e) => setUnificaCodiceNuovo(e.target.value.trim())}
                    placeholder="es. S-001-000615"
                  />
                  <p style={{ marginTop: 16, fontSize: "0.85em", color: "#666" }}>
                    Verranno spostati: CCNL, IBAN, F24, parcellazione, referenti, prestazioni, newsletter, email servizi, forfait Zucchetti.
                    Sul nuovo codice verranno allineati: data inizio/fine elaborazioni, tipologia servizio (altro/assunzioni), pubblicazione CCNL.
                    <strong> Il vecchio codice verrà eliminato definitivamente dal CRM.</strong>
                    <br /><strong>L'operazione è in transazione: in caso di errore nulla viene modificato.</strong>
                  </p>
                </>
              ) : (
                <>
                  <p style={{ marginBottom: 8, color: "#b45309" }}>
                    <strong>⚠ Conferma unificazione</strong>
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    Da: <strong>{cliente?.codice_univoco}</strong> — {cliente?.ragione_sociale}
                  </p>
                  <p style={{ marginBottom: 16 }}>
                    A: <strong>{unificaCliente?.codice_univoco}</strong> — {unificaCliente?.ragione_sociale}
                  </p>
                  {cliente?.ragione_sociale !== unificaCliente?.ragione_sociale && (
                    <p style={{ color: "#dc2626", marginBottom: 12 }}>
                      ⚠ ATTENZIONE: le due ragioni sociali sono diverse. Verifica di star unificando la stessa azienda.
                    </p>
                  )}
                  <p>L'operazione è irreversibile. Procedere?</p>
                </>
              )}
            </div>
          </Modal>,
          document.getElementById("portalModal")
        )}

      <div className="page-container">
        {cliente ? (
          <TabPanel
            title={`${cliente?.codice_fiscale} - ${cliente?.codice_univoco}${
              cliente?.codice_parcellazione
                ? ` - ${cliente.tipologia_fatturazione}${cliente.codice_parcellazione} - `
                : " - codice_parce - "
            }${cliente?.ragione_sociale}`}
            tab={tab}
            setTab={setTab}
            tabs={tabs}
            content={content}
          />
        ) : (
          <div className="flex justify-center items-center h-64">
            <div className="text-lg">Nessun cliente trovato</div>
          </div>
        )}
      </div>
      {/* <div className="flex w-full min-h-fit justify-end">
          <Button
            className="success-button"
            text="salva"
            type="button"
            icon={<MdCheck className="button-icon" />}
            onClick={async () => {
              console.log("salva");
            }}
          />
        </div> */}
    </>
  );
};
